

/** Component for product functions */
export function product(){
    var _THIS = this;
    this.elemContainer = null;
    this.ajaxProdInfo = null;
    this.selectedSKUObj = null;
    this.productData = null;
    this.addedPopupInstance = null;
    this.recentlyIns = null;
    var isQuickview = false;    

    this.init=function(elemcontainer){
        this.elemContainer = elemcontainer;
        this.productData = JSON.parse($(_THIS.elemContainer + " .product-information").attr("data-product"));

        if($(_THIS.elemContainer).hasClass("layout-quickview")){
            isQuickview = true;
        };
        
      
       
        (async () => {
            const { recentlyViewed,initPromoFlags, initPromoNames } = await import(theme.components.commonURL);

            if(!isQuickview){
                _THIS.recentlyIns = new recentlyViewed();
                _THIS.recentlyIns.saveRecentlyViewed(_THIS.productData.handle) 
            }

            initPromoFlags(_THIS.elemContainer + " .product-item-promo-flag");
            initPromoNames(_THIS.elemContainer + " .product-item-promo-name");
        })();
        
        registerEvents();
    }    

    this.getProductInformationByHandle = function(phandle,callback){

        if(typeof(_THIS.ajaxProdInfo)!=='undefined'){
            if(_THIS.ajaxProdInfo!==null && _THIS.ajaxProdInfo!=='undefined'){
                _THIS.ajaxProdInfo.abort();
            }
        }

        _THIS.ajaxProdInfo = $.ajax({
            type: 'GET',
            url:window.Shopify.routes.root + 'products/' + phandle + '?view=customproduct.json',
            success: function(response) {
                var json_response = JSON.parse(response);
                if(callback != null) return callback.call(this,json_response);
            },
            error: function(status) {
                console.warn( 'ERROR', status );
            }
        })

    }
   
    var displayProductAdded = function(addeddata){

        if(typeof($.fancybox)=="object"){
            $.fancybox.close("true");
        }



        //Hide any header menu
        $("body").removeClass("search-active"); 
        $("body").removeClass("myaccount-login-active"); 
        $("body").removeClass("menu-active");
  

        $("#search-dropdown").removeClass("active");  
        $("#main-menu").removeClass("active");
        $("#myaccount-login").removeClass("active");



       
        var arrAdded = []
         arrAdded.push(addeddata.handle);

        (async () => {
            const { getProductsInformation, getJsonProductInformation, headerBagIcon, miniCart } = await import(theme.components.commonURL);

            getProductsInformation(arrAdded,false,function(data){
                        
                

                var instHeaderBagIcon = new headerBagIcon();
                instHeaderBagIcon.updateBagIcon(null);

                var htmlData = "";
                for(var i=0;i<data.length;i++){
                    htmlData+= data[i].response;
                }
                $("#added-product .added-product-image").html(htmlData);
                
                
                $("#added-product .added-product-title").html(addeddata.product_title);   
                //As we want to limit the amount of ajax request 
                //We display other added product info from the generated product card
                $("#added-product .added-product-style").html($("#added-product .product-item-style").html());   

                console.log(_THIS.productData)
                
                for(var i=0;i<_THIS.productData.variants.length;i++){
                    
                    if(_THIS.productData.variants[i].id == addeddata.id){
                        //console.log(_THIS.productData.variants[i])

                       updateProductPrice("#added-product",_THIS.productData.variants[i])     
                       break;
                    }
                }



                //$("#added-product .added-product-price").html($("#added-product .product-price-wrap").html());   
                if(_THIS.productData.product_type!=="Gift Card"){
                    $("#added-product .added-product-colour").removeClass("hide").find("span").html(addeddata.variant_options[0]);
                    $("#added-product .added-product-size").removeClass("hide").find("span").html(addeddata.variant_options[1]);  
                }else{
                    $("#added-product .added-product-colour").addClass("hide").find("span").html("");
                    $("#added-product .added-product-size").addClass("hide").find("span").html("");  

                }

                $("#added-product .added-product-quantity").find("span").html(addeddata.quantity);  
                

                (async () => {
                const { default:models } = await import(theme.components.modelsURL);
    
                   
                    $("#added-product").addClass("active")
                    $("body").addClass("added-product-active")
                    models.updateModelsDisplay("#added-product .product-media");
                })();
            });

            //You may also like

            getJsonProductInformation(addeddata.handle,function(ymldata){
                var arrAlsoLikeProducts = [];    
                var isHideYMAL = false;

                if(typeof(ymldata.metafields.Linked_02)!='undefined' && ymldata.metafields.Linked_02 !== null){
                    //console.log("YMAL length: " + ymldata.metafields.Linked_02.length)
                    if(ymldata.metafields.Linked_02.length > 0){
                        isHideYMAL = false;
                        $("#addedproduct-also-like, #added-product-ymal-title, .added-product-ymal-spacer").removeClass("hide")
                        $("#added-product-wrapper").addClass("hasYMAL");
                        arrAlsoLikeProducts.push.apply(arrAlsoLikeProducts,_THIS.productData.metafields.Linked_02);

                        getProductsInformation(arrAlsoLikeProducts,true,function(pdata){
                            //updating the YMAL products
                            if(arrAlsoLikeProducts.length > 0){
                                var htmlContentALPROD = "";
                                for(var i=0;i<arrAlsoLikeProducts.length;i++){
                                    if(i<4){
                                        htmlContentALPROD += findCardHTMLContent(arrAlsoLikeProducts[i]["value"],pdata)
                                    }
                                    
                                }
                                $("#addedproduct-also-like .wrap-inner-slideshow").html(htmlContentALPROD);
                                (async () => {
                                    const { default:models } = await import(theme.components.modelsURL);
                        
                                   // if(!isQuickview){
                                        //We update the main image first
                                        //console.log("updating media")
                                        models.updateModelsDisplay("#addedproduct-also-like .product-media");
                                   // }
                                    //reconstructCarousel("#addedproduct-also-like",htmlContentALPROD,arrAlsoLikeProducts.length);
                                })();    
                            }

                        })

                    }else{
                        isHideYMAL = true;
                    }
                }else{
                    isHideYMAL = true;
                }
                

                if (isHideYMAL){
                    //we reset the Grid of the added product overlay content
                    $("#addedproduct-also-like").addClass("hide")
                    $("#added-product-info").addClass("width-lg-12")
                }else{
                    $("#addedproduct-also-like").removeClass("hide")
                    $("#added-product-info").removeClass("width-lg-12")
                }



            })

        })();

    }


    var renderProductFlags = function(salePrice,pproducttype,arrflags){
	

        var arrFlagTagsType = theme.allFlagsList.split(",")
        var isFlagFound = false 
        var retFlagHtml = '' 
        var flagPromotHtml = '';
        var flagClass = '' ;
        var flagHtml ='';
        var flagPromotionName = '';
        var flagPromotionStart = '';
        var flagPromotionEnd = '';
        var flagPromotionFlag = '';
        var isFlagPromoFound = false;
    
        //Search for Promotion Flags
    
        for (var promof=0;promof<arrflags.length;promof++){
            var cflagTagType = arrflags[promof].split('__')[0];
            var cflagTagValue = arrflags[promof].split('__')[1];
            
            if (cflagTagType == 'PromotionName') {
                flagPromotionName = cflagTagValue;
            
            }else if(cflagTagType == 'PromotionStart'){
                flagPromotionStart = cflagTagValue;
            }else if(cflagTagType == 'PromotionEnd'){
                flagPromotionEnd = cflagTagValue;
            }else if(cflagTagType == 'PromotionFlag'){
                flagPromotionFlag = cflagTagValue;
                if(cflagTagValue!==""){
                    isFlagPromoFound = true;
                }
            }else{
    
            }
        }
    
    
    
        for (var i=0;i<arrFlagTagsType.length;i++){
            var searchFlagTagType = arrFlagTagsType[i];
            for (var j=0;j<arrflags.length;j++){
                var currentflagTagType = arrflags[j].split("__")[0];
                if (searchFlagTagType == currentflagTagType){
                    
                    
                    if(arrflags[j].split("__").length>1){
                        var currentflagTagValue = (arrflags[j].split("__")[1]).toLowerCase();
                    }else{
                        var currentflagTagValue = (arrflags[j].split("__")[0]).toLowerCase();
                    }
                    
    
    
                    if(currentflagTagValue == 'yes'){
                        isFlagFound  = true;
                        flagClass = searchFlagTagType.toLowerCase();
                        switch(searchFlagTagType) {
                            case 'OnlineExclusive':
                              // code block
                                  flagHtml = theme.flags.online_exclusive;
                                  break;
                            case 'ComingSoon':
                                flagHtml = theme.flags.coming_soon;
                                break;  
                            case 'Sale':
                                flagHtml = salePrice; 
                                  break;
                            case 'New':
                                flagHtml = theme.flags.new;
                                  break;
                            case 'Outlet':
                                flagHtml = theme.flags.outlet;
                                  break;
                            case 'Bestseller':
                                flagHtml = theme.flags.bestseller;
                                  break;
                            default:
                                flagHtml = '';
                          }
                          break;	
                    }
                } 
            }
            if (isFlagFound) {
                break;
            }
        }
        /*
        if (theme.productsPromotion.global.enabled){
            isFlagPromoFound = false;
            if(theme.productsPromotion.global.flag!==''){
                isFlagPromoFound = true;
                flagPromotionFlag = theme.productsPromotion.global.flag;
            }
            flagPromotionStart 	= theme.productsPromotion.global.date_start;
            flagPromotionEnd 	= theme.productsPromotion.global.date_end;
        }
        */
        
        for (var j=0;j<arrflags.length;j++){
                var currentflagTagType = arrflags[j] .split("__")[0];
                
        }
        
        if (theme.productsPromotion.global.enabled){
        
            //console.log("Flag: " + theme.productsPromotion.global.product_promotion_types);
            
            if(theme.productsPromotion.global.product_promotion_types != ""){
                var includedTypes = theme.productsPromotion.global.product_promotion_types.split(", ");
                var includedTypesTotal = includedTypes.length;
                var includedTypesFound = 0;
                
                
                if (includedTypesTotal > 0) {
                    for (var j=0;j<includedTypesTotal;j++){
                        if(pproducttype == includedTypes[j]){
                            includedTypesFound = 1;
                        }
                    }
                }else{
                    includedTypesFound = 1;
                }
            }else{
                includedTypesFound = 1;
            }
        
            
            
            if (includedTypesFound == 1) {
            
                var includedTags = theme.productsPromotion.global.tags_included.split(", ");
                var excludedTags = theme.productsPromotion.global.tags_excluded.split(", ");
                var includedTagsTotal = includedTags.length;
                var excludedTagsTotal = excludedTags.length;
                var includedTagsFound = 0;
                var excludedTagsFound = 0;
                
                //Make sure array is not created with a blank index when settings is blank
                if(theme.productsPromotion.global.tags_included == ""){
                    includedTags = [];
                    includedTagsTotal = 0;
                }
        
                if(theme.productsPromotion.global.tags_excluded == ""){
                    excludedTags = [];
                    excludedTagsTotal = 0;
                }
                
                if (includedTagsTotal > 0) {
                    for (var j=0;j<includedTagsTotal;j++){
                        for (var promof=0;promof<arrflags.length;promof++){
                            if(arrflags[promof] == includedTags[j]){
                                includedTagsFound++;
                            }
                        }
                    }
                }
                
                if(excludedTagsTotal > 0){
                    //if(includedTagsFound == includedTagsTotal){
                        for (var j=0;j<excludedTagsTotal;j++){
                            for (var promof=0;promof<arrflags.length;promof++){
                                if(arrflags[promof] == excludedTags[j]){
                                    excludedTagsFound++;
                                }
                            }
                        }
                    //}
                }
                
                isFlagPromoFound = false;
                flagPromotionFlag = theme.productsPromotion.global.flag;
            
                if(includedTagsTotal > 0) {
                    if(includedTagsFound > 0) {
                        isFlagPromoFound = true;
                    }
                }else{
                    isFlagPromoFound = true;
                }
            
                if(excludedTagsFound > 0) {
                    isFlagPromoFound = false;
                }
                
                flagPromotionStart = theme.productsPromotion.global.date_start;
                flagPromotionEnd = theme.productsPromotion.global.date_end;
            }
        }
        
    
        if (isFlagPromoFound){
            flagPromotHtml += '<div data-promo-start="' + flagPromotionStart+'" data-promo-end="' + flagPromotionEnd  + '" class="product-item-promo-flag hide"><span class="flag promotion">' + flagPromotionFlag + '</span></div>';
        }
    
    
        if (isFlagFound){
            if (flagHtml != ''){
                retFlagHtml += '<div class="product-item-flag' + (isFlagPromoFound ? ' hide':'') + '"><span class="flag ' + flagClass+'">' + flagHtml + '</span></div>';
            }
        }
        
        return flagPromotHtml + retFlagHtml;
    }

    var renderProductPromoName = function(pproducttype, arrflags,pmetafields){
        var flagPromotionName = '';
        var isFlagPromoNameFound = false;
        var flagPromotHtml = '';
        var flagWarehouse = false;
        var flagPromotionStart  =  '';
        var flagPromotionEnd = '';
        
        for (var promof=0;promof<arrflags.length;promof++){
            var cflagTagType = arrflags[promof].split('__')[0];
            var cflagTagValue = arrflags[promof].split('__')[1];
            
            if (cflagTagType == 'PromotionName') {
                flagPromotionName = cflagTagValue;
                isFlagPromoNameFound = true;
            }else if(cflagTagType == 'PromotionStart'){
                flagPromotionStart = cflagTagValue;
            }else if(cflagTagType == 'PromotionEnd'){
                flagPromotionEnd = cflagTagValue;
            }else if (cflagTagType == 'warehouse') {
                flagWarehouse = true;
            }else {
    
            }
        }
        
        if (theme.productsPromotion.international.enabled){
            if(theme.productsPromotion.international.international_promotion_types != ""){
                var includedIntTypes = theme.productsPromotion.international.international_promotion_types.split(", ");
                var includedIntTypesTotal = includedIntTypes.length;
                var includedIntTypesFound = 0;
                
                if (includedIntTypesTotal > 0) {
                    for (var j=0;j<includedIntTypesTotal;j++){
                        if(pproducttype == includedIntTypes[j]){
                            includedIntTypesFound = 1;
                        }
                    }
                }else{
                    includedIntTypesFound = 1;
                }
            }else{
                includedIntTypesFound = 1;
            }
        }
        
        
        if (theme.productsPromotion.global.enabled){
            
            
        
            //console.log("Name: " + theme.productsPromotion.global.product_promotion_types);
            
            if(theme.productsPromotion.global.product_promotion_types != ""){
                var includedTypes = theme.productsPromotion.global.product_promotion_types.split(", ");
                var includedTypesTotal = includedTypes.length;
                var includedTypesFound = 0;
                
                if (includedTypesTotal > 0) {
                    for (var j=0;j<includedTypesTotal;j++){
                        if(pproducttype == includedTypes[j]){
                            includedTypesFound = 1;
                        }
                    }
                }else{
                    includedTypesFound = 1;
                }
            }else{
                includedTypesFound = 1;
            }
            
            if (includedTypesFound == 1) {
            
                var includedTags = theme.productsPromotion.global.tags_included.split(", ");
                var excludedTags = theme.productsPromotion.global.tags_excluded.split(", ");
                var includedTagsTotal = includedTags.length;
                var excludedTagsTotal = excludedTags.length;
                var includedTagsFound = 0;
                var excludedTagsFound = 0;
                
                
                /*console.log("includedTags");
                console.log(includedTags);
                console.log("excludedTags");
                console.log(excludedTags);
                
                console.log("tags_included: " + theme.productsPromotion.global.tags_included)
                console.log("tags_excluded: " + theme.productsPromotion.global.tags_excluded)
                console.log("includedTagsTotal: " +  includedTagsTotal)
                console.log("excludedTagsTotal: " + excludedTagsTotal)*/
                
                //Make sure array is not created with a blank index when settings is blank
                if(theme.productsPromotion.global.tags_included == ""){
                    includedTags = [];
                    includedTagsTotal = 0;
                }
        
                if(theme.productsPromotion.global.tags_excluded == ""){
                    excludedTags = [];
                    excludedTagsTotal = 0;
                }
                
                if (includedTagsTotal > 0) {
                    for (var j=0;j<includedTagsTotal;j++){
                        for (var promof=0;promof<arrflags.length;promof++){
                            if(arrflags[promof] == includedTags[j]){
                              console.log(arrflags[promof] + " == " + includedTags[j])
                                includedTagsFound++;
                            }
                        }
                    }
                }
                
                //console.log("includedTagsFound: " + includedTagsFound);
                
                if(excludedTagsTotal > 0){
                    //if(includedTagsFound == includedTagsTotal){
                        for (var j=0;j<excludedTagsTotal;j++){
                            for (var promof=0;promof<arrflags.length;promof++){
                                if(arrflags[promof] == excludedTags[j]){
                                    excludedTagsFound++;
                                }
                            }
                        }
                    //}
                }
                //console.log("excludedTagsFound: " + excludedTagsFound);
                
                isFlagPromoNameFound = false;
                flagPromotionName = theme.productsPromotion.global.name;
            
                if(includedTagsTotal > 0) {
                    if(includedTagsFound > 0) {
                        isFlagPromoNameFound = true;
                    }
                }else{
                    isFlagPromoNameFound = true;
                }
                
                if(excludedTagsFound > 0) {
                    isFlagPromoNameFound = false;
                }
                
                //console.log("isFlagPromoNameFound: " + isFlagPromoNameFound);
                
                flagPromotionStart 	= theme.productsPromotion.global.date_start;
                flagPromotionEnd 	= theme.productsPromotion.global.date_end;
            }
            
        }
        
        if (isFlagPromoNameFound){
    
            var promoterms = ""
            var promoclass = ""
            var promoicon = ""
    
            if(theme.productsPromotion.global.terms!==""){
                promoterms = theme.productsPromotion.global.terms 
            }else{
                //Add the tooltip if exists
                //Metafield Update 2022
                if(pmetafields!==null && typeof(pmetafields)!=='undefined'){
                    if(typeof(pmetafields.PromoTerms)!=='undefined'){
                        if(pmetafields.PromoTerms!==""){
                            promoterms = pmetafields.PromoTerms
                        }
                    }
                }
            }
            
            if(promoterms != ""){
                promoclass = " promo-term-popup"	
                //promoicon = '<div class="promo-terms"><span class="info-icon"'+ promoterms +'></span></div>'
                promoicon = ' <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>';
            }
            
            //flagPromotHtml += '<div data-promo-start="' + flagPromotionStart+'" data-promo-end="' + flagPromotionEnd  + '" class="product-item-promo-name hide"><span class="promotion' + promoclass + '"' + promoterms +'>' + flagPromotionName + '</span>' + promoicon + '</div>';

            flagPromotHtml +=    '<div class="product-item-promo-name hide" data-promo-start="' +flagPromotionStart+'" data-promo-end="' +  flagPromotionEnd  + 
                                    '"><span class="promotion' + promoclass  + '"' +
                                    (promoterms != "" ? ' data-title="' +  flagPromotionName + '" data-content="'+ promoterms + '"':"") + '>' + flagPromotionName + (promoterms != "" ? promoicon :"")  + '</span></div>'


        }else {
            
            if ( flagWarehouse == true ) {
                if( includedIntTypesFound == 1){
                    if (theme.productsPromotion.international.enabled){
                        if(theme.productsPromotion.international.terms != ""){
                            promoclass = " promo-term-popup"	
                            //promoicon = '<div class="promo-terms"><span class="info-icon"'+ theme.productsPromotion.international.terms +'></span></div>'
                        }
                        
                       // flagPromotHtml += '<div class="product-item-promo-name"><span class="promotion' + promoclass + '"' + theme.productsPromotion.international.terms +'>' + theme.productsPromotion.international.name + '</span>' + promoicon + '</div>';

                       flagPromotHtml +=  '<div class="product-item-promo-name"><span ' + 
                        (theme.productsPromotion.international.terms != "" ? ' data-title="' + theme.productsPromotion.international.name +  '" data-content="' + theme.productsPromotion.international.terms + '"' :"") + 
                         ' class="promotion' + (theme.productsPromotion.international.terms != ""? ' promo-term-popup':'') + '">' + theme.productsPromotion.international.name + 
                         (theme.productsPromotion.international.terms != "" ?' <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>':'') + 
                         '</span></div>'
                        
                    }
                }
            }
            
            
        }
    
        return flagPromotHtml;
    }



    var sendGAEvent = function(category,action,label){
        if (typeof(gtag) != "undefined") {
            //ga('send', 'event', category, action.toLowerCase(), label);
            gtag('event',action.toLowerCase(),{
                'category':category,
                'label':label
            })

        }
    }


    var sendG4Event = function (eventname){
        var selectedVariantOj = null;
        for(var i=0;i<_THIS.productData.variants.length;i++){
            if(_THIS.productData.variants[i].id == _THIS.selectedSKUObj.variantid){
                selectedVariantOj = _THIS.productData.variants[i];
            }
        }

        //console.log(_THIS.productData)

        //console.log(selectedVariantOj);



        var g4_currency  = Shopify.currency.active;
        var g4_transaction_id = "T_" + (+new Date).toString(36);

        var g4_price = 0.00;
            g4_price = parseFloat(selectedVariantOj.price).toFixed(2);
        var g4_items = 
            {
              item_id: selectedVariantOj.sku,
              item_name: _THIS.productData.title,
              currency: g4_currency,
              index: 0,
              item_variant: selectedVariantOj.option1,
              price:g4_price 
            }

            var g4_discount = 0.00;
            if(selectedVariantOj.compare_at_price!=="0.00"){
                g4_discount = parseFloat(parseFloat(selectedVariantOj.compare_at_price).toFixed(2) - parseFloat(selectedVariantOj.price).toFixed(2)).toFixed(2)
                g4_items.discount = g4_discount
            }

            //console.log(g4_items)

            if(eventname == "add_to_cart"){

                if(typeof(gtag)!=='undefined'){
                    gtag("event", "add_to_cart", {
                        transaction_id: g4_transaction_id ,
                        value: g4_price,
                        currency: g4_currency,
                        items: [g4_items]
                    });
    
                }

            }
    }
    


    var updateBISID = function(selvariantobj){
        $(_THIS.elemContainer + " a.custom-BIS").attr("data-variant-id",selvariantobj.id);

    }

    var updateUPI = function(selvariantobj){    
      
        //Limiting  this function to be excuted only on product page and not within quickview;
        
        if(!isQuickview){
            $(_THIS.elemContainer + " #sis-upi").text(selvariantobj.barcode);
            if(typeof(stockInStore)=="object"){
                stockInStore.updateCNCStatus({'index_type':'upi','index_value':selvariantobj.barcode},true)
              }
        }
        
    }

    var updateProductPrice = function(container,selvariantobj){
        var elemContainer  = _THIS.elemContainer
        if(container !== null){
            elemContainer = container;
        }
        
        var priceContainer  = $(elemContainer  + " .product-price-wrap");
        //Update Price
        var pricehtml= "";
        pricehtml +='<div class="product-price' + (selvariantobj.compare_at_price > selvariantobj.price? " price-on-sale":"") + '">';
        pricehtml +=	'<span class="price-item' + (selvariantobj.compare_at_price > selvariantobj.price? " pre-sale":"") + '">';

        if(selvariantobj.compare_at_price > selvariantobj.price){
            pricehtml +=	selvariantobj.compare_at_price_currency;
        }else{
            pricehtml += selvariantobj.price_currency;
        }
        pricehtml += '</span>';

        if(selvariantobj.compare_at_price > selvariantobj.price){
            pricehtml += '<span class="price-item sale">' +  selvariantobj.price_currency + '</span>'
        }
        pricehtml += '</div>'
        priceContainer.html(pricehtml)

        //Update AfterPay Price
        $(elemContainer + " .afterPayPrice").html( selvariantobj.afterpayprice);
    }


    var updateQuantityInput = function(selvariantobj){
        //console.log(_THIS.selectedSKUObj)
        if(_THIS.selectedSKUObj == null){ //we prevent quantity update unless a size is selectec
            $(_THIS.elemContainer + ' .product-control-quantity input.input_quantity').attr("max","1")    
            $(_THIS.elemContainer + ' .product-control-quantity a.minus').addClass("disabled")
            $(_THIS.elemContainer + ' .product-control-quantity a.plus').addClass("disabled")
            $(_THIS.elemContainer + ' .product-control-quantity input.input_quantity').val("1")
        }else{
            $(_THIS.elemContainer + ' .product-control-quantity input.input_quantity').attr("max",selvariantobj.inventory_quantity)    
            $(_THIS.elemContainer + ' .product-control-quantity a.minus').removeClass("disabled")
            $(_THIS.elemContainer + ' .product-control-quantity a.plus').removeClass("disabled")
            $(_THIS.elemContainer + ' .product-control-quantity input.input_quantity').val("1")

        }
    }

    var resetStockIndicator = function(){
        //Show/hide stock indicator
        $(_THIS.elemContainer + ' .product-stock-indicator .stock-indicator-available').addClass("hide")
        $(_THIS.elemContainer + ' .product-stock-indicator .stock-indicator-limit .stock-remaining').val("")
        $(_THIS.elemContainer + ' .product-stock-indicator .stock-indicator-limit').addClass("hide")
        $(_THIS.elemContainer + ' .product-stock-indicator').addClass("hide")

    }
    var updateStockIndicator = function(selvariantobj){
        
        resetStockIndicator();
        if(selvariantobj.available){
            $(_THIS.elemContainer + ' .product-stock-indicator').removeClass("hide")
            if(selvariantobj.inventory_quantity>3){
                $(_THIS.elemContainer + ' .product-stock-indicator .stock-indicator-available').removeClass("hide")
            }else{
                $(_THIS.elemContainer + ' .product-stock-indicator .stock-indicator-limit .stock-remaining').text(selvariantobj.inventory_quantity)
                $(_THIS.elemContainer + ' .product-stock-indicator .stock-indicator-limit').removeClass("hide")
            }
        }else{
            $(_THIS.elemContainer + ' .product-stock-indicator').addClass("hide")
        }
    }

    var updateAddToBagDisplay = function(selvariantobj){

        //Check the product availablity
        var isAvailable = true;

        if(!_THIS.productData.available){
            isAvailable = false;

        }else{
            if(!selvariantobj.available){
                isAvailable = false;
            }
        }

        if(isAvailable){
            $(_THIS.elemContainer + ' .product-form-controls').removeClass("size-not-available");
            $(_THIS.elemContainer + ' .product-form-controls button[name=add] span').text(theme.strings.addToCart);
		    $(_THIS.elemContainer + ' .product-form-controls button[name=add]').prop("disabled",false)
        }else{
            $(_THIS.elemContainer + ' .product-form-controls').addClass("size-not-available");
            $(_THIS.elemContainer + ' .product-form-controls button[name=add] span').text(theme.strings.soldOut);
		    $(_THIS.elemContainer + ' .product-form-controls button[name=add]').prop("disabled",true)
        }
    }

    var updateProductSKU = function(elem){
        var sizeElemCon = elem.parent();
        _THIS.selectedSKUObj = {
            upi:sizeElemCon.attr("data-variant-barcode"),
            variantid:sizeElemCon.attr("data-variant-id"),
            inventory: sizeElemCon.attr("data-variant-inventory")   
        }
        var variantobj = _THIS.productData.variants
        var vlength = variantobj.length;
        for(var i=0;i<vlength;i++){
			if(variantobj[i].id == _THIS.selectedSKUObj.variantid){
			
                updateUPI(variantobj[i])
                updateBISID(variantobj[i]);
                updateProductPrice(null,variantobj[i]);
                updateStockIndicator(variantobj[i]);
                updateAddToBagDisplay(variantobj[i]);
                updateQuantityInput(variantobj[i])
                var countrySize = localStorage.getItem("country-region-size");
                var selSizeName = variantobj[i].option2;
                //console.log(_THIS.productData)
                if(_THIS.productData.product_type == "Gift Card"){
                    selSizeName = variantobj[i].price_currency;
                }
                if(countrySize){
                //$(_THIS.elemContainer + ' .sel-size-name').html(countrySize)
                }else{
                //$(_THIS.elemContainer + ' .sel-size-name').html(selSizeName)   
                } 
                break;
			}
		}

    }

    var updateProductCarousels = function(){

        (async () => {
            const { getProductsInformation, onlyUniqueHandle } = await import(theme.components.commonURL);

            var arrAllExtraProductsHandles 	= [];
            var arrMatchinLineProducts 		= [];
            var arrAlsoLikeProducts 		= [];
            
            
            if(typeof(_THIS.productData.metafields.Linked_01)!='undefined' && _THIS.productData.metafields.Linked_01 !== null){
                if(_THIS.productData.metafields.Linked_01.length >0){
                    arrAllExtraProductsHandles.push.apply(arrAllExtraProductsHandles,_THIS.productData.metafields.Linked_01);
                    arrMatchinLineProducts.push.apply(arrMatchinLineProducts,_THIS.productData.metafields.Linked_01);
                }
            }


            if(typeof(_THIS.productData.metafields.Linked_02)!='undefined' && _THIS.productData.metafields.Linked_02!==null){
                if(_THIS.productData.metafields.Linked_02.length >0){
                    arrAllExtraProductsHandles.push.apply(arrAllExtraProductsHandles,_THIS.productData.metafields.Linked_02);
                    arrAlsoLikeProducts.push.apply(arrAlsoLikeProducts,_THIS.productData.metafields.Linked_02);
                }
            }
            

            if(arrAllExtraProductsHandles.length>0){
                var uniquearrAllExtraProductsHandles = onlyUniqueHandle(arrAllExtraProductsHandles)

                getProductsInformation(uniquearrAllExtraProductsHandles,true,function(data){
                    //console.log(arrMatchinLineProducts)
                    //updating the MATCHING LINE products
                    if(arrMatchinLineProducts.length > 0){
                        var htmlContentMLPROD = "";
                        for(var i=0;i<arrMatchinLineProducts.length;i++){
                            htmlContentMLPROD += findCardHTMLContent(arrMatchinLineProducts[i]["value"],data)
                        }
                    }
                    reconstructCarousel("div[id$='__asseenon']",htmlContentMLPROD,arrMatchinLineProducts.length);
    
                    //updating the YMAL products
                    if(arrAlsoLikeProducts.length > 0){
                        var htmlContentALPROD = "";
                        for(var i=0;i<arrAlsoLikeProducts.length;i++){
                            htmlContentALPROD += findCardHTMLContent(arrAlsoLikeProducts[i]["value"],data)
                        }
                    }
                    reconstructCarousel("div[id$='__related']",htmlContentALPROD,arrAlsoLikeProducts.length);

                });

             
            }


        })();

    }

    var reconstructCarousel  = function(elem,htmlContent,totalslides){
        //console.log("reconstructing carousel" + elem)
         //get the parent container of carousel
        var carouselParent = $(elem);
        var carousel = carouselParent.find(".wrap-inner-slideshow");

         carousel.html(htmlContent);


         (async () => {
            const { carousel } = await import(theme.components.commonURL);
            var instCarousel = new carousel();
            instCarousel.init(elem);
        })();
    

         (async () => {
            const { default:models } = await import(theme.components.modelsURL);

            if(!isQuickview){
                //We update the main image first

                models.updateModelsDisplay(elem + " .product-media");
            }

        })();

    }
    var findCardHTMLContent = function(handle,data){
        var retVal = "";
        for(var i=0;i<data.length;i++){
            if(data[i].handle == handle){
                retVal = data[i].response;
                break;
            }
        }
        return retVal;
    }    

    var updateProductDisplay = function(){
        
        var isBackInStore = false;
        var datatagslength = _THIS.productData.tags.length;
        for (var t=0;t<datatagslength;t++){
            var dnTags = _THIS.productData.tags[t].toLowerCase()
            if(dnTags == 'lifecycle__ongoing'){
                isBackInStore = true;
                break;
            }
        }

        if(isBackInStore){
            $(_THIS.elemContainer + " .product-information").addClass("backinstock");
        }else{
            $(_THIS.elemContainer + " .product-information").removeClass("backinstock");
        }
                
        $(_THIS.elemContainer + " a.custom-BIS").attr("data-product-handle",_THIS.productData.handle);
        
        
        if(_THIS.productData.available){
            $(_THIS.elemContainer  + " .product-information").addClass("productavailable").removeClass("productnotavailable")
        }else{
            $(_THIS.elemContainer  + " .product-information").removeClass("productavailable").addClass("productnotavailable")
        }
        

        //Clear selected size
        $(_THIS.elemContainer + " .sel-colour-name").html("");

        //Updating data-title (for alt tags)



        var styleString = ''
        var colourString = ''
        var brandString = 'Triumph'
        var titleString = _THIS.productData.title 
        var producttitle = titleString;
     
        var searchLocaleStylePrimTag = "StylePrimary__"  + Shopify.locale


        for (var t=0;t<datatagslength;t++){
            var dnTags = _THIS.productData.tags[t]
            if(dnTags.indexOf(searchLocaleStylePrimTag) !=-1){
                styleString = dnTags.split("__")[2]
                break;
            }
        }

        for (var j=0;j<_THIS.productData.options.length;j++){
            var opname = _THIS.productData.options[j].name.toLowerCase();
            if(opname == 'colour' || opname == 'color'){
                colourString = _THIS.productData.options[j]['values'][0].toLowerCase();
                colourString = colourString.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
                break;
            }
        }


        colourString.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());


        
        if($(document.body).hasClass("brand-sloggi")){
            brandString = 'Sloggi'
        }
    
        
              
        
    
        if (styleString != ''){
            producttitle = brandString +  " "  +  titleString  +  " - "  +  colourString  +  " - "  +  styleString 
        }else{
            producttitle = brandString +  " "  +  titleString  +  " - "  +  colourString  
        }
            
        $(_THIS.elemContainer + " .product-media").attr("data-title",producttitle);


        //

        //Updating product Images
        $(_THIS.elemContainer + " .product-media").removeClass("bynder");
        if(_THIS.productData.metafields.Models!==null){
            $(_THIS.elemContainer + " .product-media").attr("data-models",_THIS.productData.metafields.Models);
            if($(_THIS.elemContainer + " .product-media").attr("data-models").indexOf('contentstore.triumph.com') > -1){
              $(_THIS.elemContainer + " .product-media").addClass("bynder");
            }
        }


        (async () => {
            const { default:models } = await import(theme.components.modelsURL);

            if($(_THIS.elemContainer).hasClass("layout-quickview")){
                //We update the main image first
                models.updateQuickViewModelsDisplay();
            }else{
                //We update the main image first
                models.updateModelsDisplay(_THIS.elemContainer + " .product-media");
            }
            //Then we recreate all related 

        })();
        
        //Updating Product Name
        
        //Updating Product Style

        //Update Colour Name
        var getColourName = _THIS.productData.variants[0].option1;
        $(_THIS.elemContainer + " .sel-colour-name").html(getColourName.toLowerCase());


        //Resetting Size Name
        //$(_THIS.elemContainer + " .sel-size-name").html("");
        //Reset Stock Indicator
        resetStockIndicator();
        
        

        //Updating Product Sizes
        //Get update the size variation correspoding to selected colour
        var getSizeHtml = '<ul>'
        var optionHTML = '';
        var dv = _THIS.productData.variants;
        var selectedVariantObj = null;
        var dvlength = dv.length;
        var jsonSizes = null;
        var optionSelected = $('.sizeCountry option:selected').attr("data-sizes");

        if(optionSelected){
            jsonSizes = JSON.parse(optionSelected);
        }

        
        for(var i=0;i<dvlength;i++){
            if(selectedVariantObj == null){
                if(dv[i].selected){
                    selectedVariantObj = dv[i];
                }
            }
            if(jsonSizes){
              var option2 = (jsonSizes[dv[i].option2] != undefined)?jsonSizes[dv[i].option2]:dv[i].option2;      
            }else{
                var option2 = dv[i].option2;
            }
            if(dv[i].available){
                optionHTML += '<option data-variant-id="' + dv[i].id + '" value="' + dv[i].id + '" data-variant-inventory="' + dv[i].inventory_quantity + '">' + dv[i].option2 + '</option>'
                getSizeHtml += '<li class="sizeoption" data-variant-id="' + dv[i].id + '" value="' + dv[i].id + '" data-variant-option="' + dv[i].option2 + '" data-variant-barcode="' + (typeof(dv[i].barcode)!=='undefined'?dv[i].barcode:"") +'" data-variant-inventory="' + dv[i].inventory_quantity + '"><a href="#">' + option2 + '</a></li>'
            }else{
                optionHTML += '<option data-variant-id="' + dv[i].id + '" value="' + dv[i].id + '" data-variant-inventory="' + dv[i].inventory_quantity + '">' + dv[i].option2 + ' - ' + (isBackInStore?theme.strings.notifyMe:theme.strings.soldOut) + '</option>'
                getSizeHtml += '<li class="sizeoption ' + (isBackInStore?'notifyme':'soldout') + '" data-variant-option="' + dv[i].option2 + '" data-variant-id="' + dv[i].id + '" value="' + dv[i].id + '" data-variant-barcode="' + (typeof(dv[i].barcode)!=='undefined'?dv[i].barcode:"") +'" data-variant-inventory="' + dv[i].inventory_quantity + '"><a href="#">' +  option2  + (isBackInStore?'<span class="icon-notify">' + theme.icons.email + '</span>':'') + '</a></li>'
            }
        }	

        getSizeHtml += '</ul>'

        $(_THIS.elemContainer + " .sizeList").html(getSizeHtml);
        $(_THIS.elemContainer + " select[name=id]").html(optionHTML);


        //when Loading a new colour we need to update  any previous selected sku info from previous colour
        //get the selected variant
        updateProductPrice(null,selectedVariantObj)
        //updateStockIndicator(selectedVariantObj)
        updateUPI(selectedVariantObj)
        updateBISID(selectedVariantObj);
        updateQuantityInput(selectedVariantObj)

        //Updating Product Add To Bag
        updateAddToBagDisplay(selectedVariantObj)

        //Updating Wishlist button
        $(_THIS.elemContainer + " .wishlist.btn-icon.sm").html('<!-- include "wishlist-button" id: "' + _THIS.productData.id + '" -->');

        //Updating Product Tab  Information

        //Updating Related Products
        if(!$(_THIS.elemContainer).hasClass("layout-quickview")){
            updateProductCarousels();
        }

        //Update Product Tags and Promotion Name
        //Get the product flag
        var productFlagHTML = renderProductFlags(_THIS.productData.sale_price,_THIS.productData.product_type,_THIS.productData.tags);

        //Get the Promotion Name
        var productPromoHTML= renderProductPromoName(_THIS.productData.product_type,_THIS.productData.tags,_THIS.productData.metafields);

        $(_THIS.elemContainer).find(".product-item-flag").remove();
        $(_THIS.elemContainer).find(".product-item-promo-flag").remove();

        if(productFlagHTML!==""){
            $(_THIS.elemContainer).find(".product-image-wrap").prepend(productFlagHTML);
        }

        $(_THIS.elemContainer).find(".product-item-promo-name").remove();
        if(productPromoHTML!==""){
            $(_THIS.elemContainer).find(".product-price-wrap").before(productPromoHTML)
        }


        (async () => {
            const { initPromoFlags, initPromoNames } = await import(theme.components.commonURL);

            initPromoFlags(_THIS.elemContainer + " .product-item-promo-flag");
            initPromoNames(_THIS.elemContainer + " .product-item-promo-name");
        })();



    }

    

    var setSelectedElement = function(elem){
        elem.parent().siblings().removeClass("sel")
        elem.parent().addClass("sel")
    }

    var selectColour = function(elem){
        setSelectedElement(elem)
        _THIS.selectedSKUObj=null;
        _THIS.getProductInformationByHandle(elem.attr("data-product-handle"),function(data){
            _THIS.productData = data;
            updateProductDisplay();
            updateProductTabsMoreDescription();
        })
    }

    var updateProductTabsMoreDescription = function(){
        $(_THIS.elemContainer  + " .description-content-extra .moretext").html("").removeClass("loaded").addClass("hide")
        $(_THIS.elemContainer  + " .description-content-extra .moreless-button").text($(_THIS.elemContainer  + " .description-content-extra .moreless-button").attr("data-view-more"))
        $(_THIS.elemContainer  + " .description-content-extra .moreless-button").attr("data-handle",_THIS.productData.handle)
        if(_THIS.productData.metafields.MoreDescription!==null){
            $(_THIS.elemContainer  + " .description-content-extra .moretext").html(_THIS.productData.metafields.MoreDescription).addClass("loaded").addClass("hide")
            $(_THIS.elemContainer  + " .description-content-extra").removeClass("hide").addClass("has-content")
        }else{
            
            $(_THIS.elemContainer  + " .description-content-extra").addClass("hide").removeClass("has-content")
        }

        //trigger the view more
        if($(_THIS.elemContainer  + " .description-content-extra").hasClass("has-content")){
            setTimeout(function(){
                $(_THIS.elemContainer  + " .description-content-extra .moreless-button").trigger("click")
            },1000)
        }
    }

    var addToBagValidate = function(msg){
        $(_THIS.elemContainer  + " .product-add-indicator").removeClass("hide").html(msg).show();

        if(!$("#viewport").is(":visible")){
            if(!isQuickview){
                $('html, body').animate({
                    scrollTop: $(".sizeHeader").offset().top - $("#shopify-section-header").height()
                }, 1000);
            }
        }
                
        $(_THIS.elemContainer  + " .product-add-indicator").delay(3000).fadeOut(1000,"linear",function(){
            $(_THIS.elemContainer  + " .product-add-indicator").html("").addClass("hide")
        })
    }

    var displaySizeChartPopup = function(elem){

        var title = elem.text();
        var chartbrand = elem.attr("data-size-guide-brand");
        var charttype = elem.attr("data-size-guide-type");

        $(document).off("click","#sizechart-product-template .tab-scroller a");


        (async () => {
            const { checkLibrary, emailValidate,customSizeChartTabs } = await import(theme.components.commonURL);
            var insCusSizechartTabs = new customSizeChartTabs();
            checkLibrary($.fancybox, theme.components.modalLibraryURL, function(){

                $.fancybox.open('<div id="sizechart-product-template" class="layout-sizechart hide ' + chartbrand + '"><div class="wrap-content"><div class="inner-wrap"><div class="loader-content"><img src="' + theme.loaderImage + '" /></div><div class="sizechart-content"></div></div></div></div>',{
                    beforeShow : function( instance, current ) {
                        sendGAEvent('Size Chart','Click','View Size Chart - Product Page')
                        $.ajax({
                            type: 'GET',
                            
                            url: window.Shopify.routes.root + 'pages/size-charts?view=sizechart-popup',
                            success: function(response) {
                
                                
                                $("#sizechart-product-template .wrap-content .inner-wrap .sizechart-content").html(response);

                                $("#sizechart-product-template .size-chart-brand-wrap").removeClass("sel")
                                $("#sizechart-product-template #" + chartbrand).addClass("sel")
                                
                                
                                var foundType = false;
                                var selIndex = 0;
                                

                                $("#sizechart-product-template #"+ chartbrand +" .tab-scroller li").each(function(ind){
                                        
                                    if( $(this).find("a").attr("href") == ("#"+charttype) ){
                                        foundType = true;
                                        selIndex = ind
                                        $(this).addClass("sel")
                                    }
                                });

                                if(foundType && selIndex!==0){
                                    $("#sizechart-product-template #"+ chartbrand +" .tab-scroller li").eq(0).removeClass("sel")
                                    $("#sizechart-product-template #" + chartbrand + " .size-chart-wrap").eq(0).removeClass("sel")
                                }
                                
                                $( "#sizechart-product-template #"+ chartbrand + " #"+ charttype).addClass("sel")
                                

                                
                               
                                setTimeout(function(){

                                    //$("#sizechart-product-template .wrap-content .inner-wrap .sizechart-content").removeClass("hide")
                                    $("#sizechart-product-template").removeClass("hide")
                                    $("#sizechart-product-template .wrap-content .inner-wrap .loader-content").addClass("hide")
                                },500)

                                insCusSizechartTabs.init()               
                
                            },
                            error: function(status) {
                                console.warn( 'ERROR', status );
                            }
                        })
                        
                    }	
                });
        


            })
            
        })();



    
    }

    var displayBISCustomPopup = function(elem){

        var getVariantID = elem.attr("data-variant-id")

	    _THIS.getProductInformationByHandle(elem.attr("data-product-handle"),function(data){

            var dv = data.variants;
            var htmlBISNewVariants = "<option value=''>" +theme.strings.selectSize + "</option>";

            for(var i=0;i<dv.length;i++){
                if(!dv[i].available){
                    htmlBISNewVariants += '<option' + ((getVariantID!==null && getVariantID ==dv[i].id)?" selected=selected ":"")  + ' value="' + dv[i].id + '">' + dv[i].option2 + '</option>'
                }
                
            }	


            var image	=	data.featured_image.src.split('.jpg')	
            var resizeImage = image[0] + '_68x.jpg' + image[1];

            var htmlPopContent = '';
            htmlPopContent +=	'<div class="BIS-form form">'
            htmlPopContent +=		'<h2 class="BIS-form-title">' + theme.strings.product.backInStock.popup.title +'</h2>'
            htmlPopContent +=		'<p class="BIS-form-sub-title">' + theme.strings.product.backInStock.popup.introText +'</p>'
            htmlPopContent +=		'<div class="BIS-product">'
            htmlPopContent +=		'<div><img src="' + resizeImage + '" alt="' + data.featured_image.alt + '" /></div>'
            htmlPopContent +=		'<div><h3 class="BIS-form-product-name">' + data.title + '</h3>'
            htmlPopContent +=		'<div class="BIS-form-colour-name">' + theme.strings.labelColor + ': ' + dv[0].option1 + '</div></div>'
            htmlPopContent +=		'</div>'
            htmlPopContent +=		'<div class="BIS-form-wrapper">'
            htmlPopContent +=		'<div class="notification-popup hide"></div>'
            htmlPopContent +=		'<ul>'
            htmlPopContent +=			'<li>'
            htmlPopContent +=				'<select class="BIS-form-size">'
            htmlPopContent +=					htmlBISNewVariants
            htmlPopContent += 				'</select>'
            htmlPopContent +=			'</li>'		
            htmlPopContent +=			'<li>'
            htmlPopContent += 				'<input class="BIS-form-email" name="BIS-form-email" placeholder="' + theme.strings.product.backInStock.popup.emailPlaceholder +'" type="email" id="notify_email">'
            htmlPopContent +=			'</li>'		
            htmlPopContent +=			'<li>'
            htmlPopContent +=				'<button class="BIS-form-notify btn btn-black btn-block">' + theme.strings.product.backInStock.popup.notifyBtn +'</button>'
            htmlPopContent +=			'</li>'

            htmlPopContent +=		'</ul>'
            htmlPopContent +=		'<input type="hidden" class="BIS-form-product-id" value="' + data.id + '">'
            htmlPopContent +=		'<small class="BIS-form-footer">' + theme.strings.product.backInStock.popup.footerText +'</small>'
            htmlPopContent +=		'</div>'
            htmlPopContent +=	'</div>';

            $(document).off("click",".BIS-form .BIS-form-notify");
            //REGISTER EVENTS HERE
            $(document).on("click",".BIS-form .BIS-form-notify",function(e){

                var valid = true;
                var getSize = $(".BIS-form .BIS-form-size").val();
                var getEmail  = $(".BIS-form .BIS-form-email").val();
                var getProductID = $(".BIS-form .BIS-form-product-id").val();
        
                $(".BIS-form .BIS-form-size").removeClass("invalid")
                $(".BIS-form .BIS-form-email").removeClass("invalid")		
        
                if(getSize == ""){
                    $(".BIS-form .BIS-form-size").addClass("invalid")
                    valid = false;
                }
        
                if(getEmail==""){
                    $(".BIS-form .BIS-form-email").addClass("invalid")
                    valid = false;
                }else{
                    var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
                    if(reg.test(getEmail) == false) {
                        $(".BIS-form .BIS-form-email").addClass("invalid")
                        valid = false;
                    }
                }
        
                if(valid){
                    $(".BIS-form .BIS-form-notify").text( theme.strings.product.backInStock.popup.registeringMsg ).prop("disabled",true)
                    //console.log(valid)
                    BIS.create(getEmail, parseInt(getSize), parseInt(getProductID)).then(function(data){
        
                        
                        if (data.status == 'OK') {	
                            
                            $(".BIS-form .notification-popup").removeClass("hide").html( "<p>" + theme.strings.product.backInStock.popup.successMsg + "</p>" )
        
                        } else { // it was an error
        
                            $(".BIS-form .notification-popup").addClass("error").removeClass("hide").html( "<p>" + data.errors.base + "</p>" )
        
                        }
        
                        setTimeout(function(){
                            $(".BIS-form .notification-popup").addClass("hide").removeClass("error");
                            $(".BIS-form .BIS-form-email").removeClass("valid").val("");
                            $(".BIS-form .BIS-form-notify").text( theme.strings.product.backInStock.popup.notifyBtn ).prop("disabled",false)
                        },5000)
                        
                    });
        
                }
        
        
        
            });
        
            (async () => {
                const { checkLibrary, emailValidate } = await import(theme.components.commonURL);
            
                checkLibrary($.fancybox, theme.components.modalLibraryURL, function(){
                    $.fancybox.open( htmlPopContent,{
                        afterShow : function( instance, current ) {
                            var instEmailValidate = new emailValidate();
                            instEmailValidate.init($(".BIS-form .BIS-form-email"),$(".BIS-form  .BIS-form-notify"),function(validated){
                                if(validated){
                                    //console.log("validated: " + validated)
                                    $(".BIS-form  .BIS-form-notify").click();
                                }
                            })
                        }
                    });

                })
                
            })();
            
        });
    }

    var qtyUpdate = function(elem,action){

        
        if(!elem.hasClass("disabled")){

            var getMaxQuantity  = parseInt($(_THIS.elemContainer + " .input_quantity").attr("max"));

            if(getMaxQuantity <=0){
                return;
            }
            var currentQuantity = parseInt($(_THIS.elemContainer + " .input_quantity").val());
            var setQuantityValue = (action == "plus" ? currentQuantity + 1 : currentQuantity - 1)
            if(setQuantityValue <=0){
                setQuantityValue = 1
            }else{
                if(setQuantityValue >=getMaxQuantity ){
                    setQuantityValue = getMaxQuantity;
                }
            }
            $(_THIS.elemContainer + " .input_quantity").val(setQuantityValue)
        }else{
            //console.log("option disabled")
        }

    }


    var initThumbNails = function(el){

        
        var direction = "horizontal"
        var container   = el.parent().find(".thumbnails-image-slideshow-inner");
        var containerwidth = container.width();
        var slider      = el.parent().find(".thumbnails-image-slideshow");
        var slideWidth	=	slider.find(".thumb-media-slide").eq(0).width()
        var slideHeight =  slider.find(".thumb-media-slide").eq(0).height()
        if((containerwidth - slideWidth) <= 10){ //adjust with padding right
            direction = "vertical"
        }


        container.removeClass("vertical").removeClass("horizontal").addClass(direction)


    }
    var navigateThumnails = function(el,action){
        
        var direction = "horizontal";
        var container   = el.parent().find(".thumbnails-image-slideshow-inner");
        var slider      = el.parent().find(".thumbnails-image-slideshow");
        var slideWidth	=	slider.find(".thumb-media-slide").eq(0).width()
        var slideHeight =  slider.find(".thumb-media-slide").eq(0).height()

        
        //Check current scroll position
        var containerwidth = container.width();
        var containerheight = container.height();

        var scrollWidth = (slideWidth * slider.find(".thumb-media-slide").length);
            scrollWidth = Math.floor(scrollWidth); //to prevent decimal

        var scrollHeight = (slideHeight * slider.find(".thumb-media-slide").length);
            scrollHeight = Math.floor(scrollHeight); //to prevent decimal
    
        var scrollcontent = containerwidth  + container.scrollLeft();
        var scrollcontentH = containerheight  + container.scrollTop();

        
        

        if((containerwidth - slideWidth) <= 10){ //adjust with padding right
            direction = "vertical"
        }


        container.removeClass("vertical").removeClass("horizontal").addClass(direction)

        var currentThumbIndex = slider.find(".thumb-media-slide.slide-sel").index();
        
        var startIndex = 0
        var endIndex = slider.find(".thumb-media-slide").length;

        if(action =="next"){
            currentThumbIndex = currentThumbIndex + 1
        }else{
            currentThumbIndex = currentThumbIndex - 1
        }


        if(currentThumbIndex <=startIndex){
            currentThumbIndex = startIndex;
        }

        if(currentThumbIndex>=(endIndex-1)){
            currentThumbIndex = (endIndex-1);
        }


        console.log('currentThumbIndex:' + currentThumbIndex)
        
        slider.find(".thumb-media-slide").eq(currentThumbIndex).trigger("click")




        if(direction == "horizontal"){
            //console.log(containerwidth)
            //console.log(scrollWidth)
            //console.log(scrollcontent)
            if(action =="next"){
                if(scrollcontent>=scrollWidth){
                    //container.scrollLeft(0);
                    return;
                }
    
            }else{ //prev
                if(container.scrollLeft() <=0){
                    //container.scrollLeft(scrollWidth )
                    return;
                }
    
            }
            //console.log((action=="next"?(container.scrollLeft() + slideWidth): (container.scrollLeft() - slideWidth)))
            
            $(container).animate({
                scrollLeft: (action=="next"?(container.scrollLeft() + slideWidth): (container.scrollLeft() - slideWidth))
            }, 300,function(){
                //complete scrolling
            });

        }else if(direction == "vertical"){


            //console.log(containerheight)
            //console.log(scrollHeight)
            //console.log(scrollcontentH)

            if(action =="next"){
                if(scrollcontentH>=scrollHeight){
                    //container.scrollTop(0);
                    return;
                }
    
            }else{ //prev

                console.log(container.scrollTop())
                if(container.scrollTop() <=slideHeight){
                    container.scrollTop(0 )
                    return;
                }
    
            }
            //console.log((action=="next"?(container.scrollLeft() + slideWidth): (container.scrollLeft() - slideWidth)))
            
            $(container).animate({
                scrollTop: (action=="next"?(container.scrollTop() + slideHeight): (container.scrollTop() - slideHeight))
            }, 300,function(){
                //complete scrolling
            });


        }else{
            
        }
       

      
    }

    var addToBag = function(elem){
        
        if($(_THIS.elemContainer + " .product-form-controls").hasClass("size-not-available")){
            //Silently exit the function
            //console.log("size is not available")
            return;
        }

        if($(_THIS.elemContainer + " .product-form-controls").hasClass("adding")){
            //Silently exit the function
            //console.log("currently adding")
            return;
        }



        if(_THIS.selectedSKUObj!==null){
            
            var postAdddata = {
                "quantity":$(_THIS.elemContainer + " .input_quantity").val(),
                "id":_THIS.selectedSKUObj.variantid
            }
            $(_THIS.elemContainer + " .product-form-controls").addClass("adding")
            $(_THIS.elemContainer + ' .product-form-controls button[name=add] span').text(theme.strings.addingToCart);
            $.ajax({
                type: 'POST',
                url: window.Shopify.routes.root + 'cart/add.js',
                data: postAdddata,
                dataType: 'json',
                success: function(addeddata) { 
                    $(_THIS.elemContainer + " .product-form-controls").removeClass("adding")
                    $(_THIS.elemContainer + ' .product-form-controls button[name=add] span').text(theme.strings.addToCart);
                    sendGAEvent('Product','Click','Add to Shopping Bag')
                    sendG4Event("add_to_cart")
                    displayProductAdded(addeddata)
                },
                error: function(xhr, status, error){

                    addToBagValidate(xhr.responseJSON.description);
                    $(_THIS.elemContainer + " .product-form-controls").removeClass("adding")
                    $(_THIS.elemContainer + ' .product-form-controls button[name=add] span').text(theme.strings.addToCart);
               
                }
             });

        }else{

            var messageValidation = theme.strings.selectSize;
            if(_THIS.productData.product_type == "Gift Card"){
                messageValidation = theme.strings.selectAmount;
            }

            addToBagValidate(messageValidation);
            
        }
    }


    var selectSize = function(elem){
        setSelectedElement(elem)
        updateProductSKU(elem);
        
    }

    var selectTab = function(elem){
        setSelectedElement(elem)
        var getContentRefClass = "." + elem.attr("data-content") + "-content"
        $(_THIS.elemContainer + " .product-details .tab-content .content").addClass("hide")
        
        $(_THIS.elemContainer + " .product-details " + getContentRefClass).removeClass("hide")
        $(window).trigger("resize");

    }

    var registerEvents = function(){

        //Clear registered events from memory, especially useful for quickiew as 
        //multiple instances are created within a page
        $(document).off("click",_THIS.elemContainer + " .product-form__cart-submit");
        $(document).off("click",_THIS.elemContainer + " .product-item-swatches a");
        $(document).off("click",_THIS.elemContainer + " .sizeoption a");

        $(document).off("click",_THIS.elemContainer + " .sizeoption a");
        $(document).off("click",_THIS.elemContainer + " .product-control-quantity a.minus");
        $(document).off("click",_THIS.elemContainer + " .product-control-quantity a.plus");
        $(document).off("click",_THIS.elemContainer + " a.custom-BIS");
        $(document).off("click",_THIS.elemContainer + " a.size-guide-link");
        
        $(document).off("click",_THIS.elemContainer + " .promo-term-popup");

        $(document).off("click",_THIS.elemContainer + " .thumbnails-wrap .prev");
        $(document).off("click",_THIS.elemContainer + " .thumbnails-wrap .next");
        $(document).off("click",_THIS.elemContainer + " .thumb-media-slide")

        $(document).off("blur paste change",_THIS.elemContainer + " .input_quantity")

        $(document).on("blur paste change",_THIS.elemContainer + " .input_quantity",function(e){
            
            var getCurrentQuantity = $(this).val();

            if($.trim(getCurrentQuantity).length <=0){
                $(this).val(1)
            }else{
                getCurrentQuantity = parseInt($(this).val());

                if(getCurrentQuantity > parseInt($(this).attr("max"))){
                    $(this).val($(this).attr("max"))
                }else{
                    if(getCurrentQuantity<=0){
                        $(this).val(1)
                    }
                }
            }

        })

        $(document).on("click",_THIS.elemContainer + " .promo-term-popup",function(e){

            var titlePopup = $(this).attr("data-title")
            var contentPopup = $(this).attr("data-content");

            (async () => {
                const { checkLibrary } = await import(theme.components.commonURL);

            

                checkLibrary($.fancybox, theme.components.modalLibraryURL, function(){

                    if(!isQuickview){
                        $.fancybox.close("true");
                    }
    
                    _THIS.popupInstance  =  $.fancybox.open('<div class="promotionTermsPopup"><h2>' + titlePopup + '</h2><p>' + contentPopup + '</p> </div>',{
                        afterShow : function( instance, current ) {
                
                        }	
                    });
                });
            })();
        })

        $(document).on("click",_THIS.elemContainer + " a.size-guide-link",function(e){
            e.preventDefault;
            displaySizeChartPopup($(this));
            return false;
        })

        $(document).on("click",_THIS.elemContainer + " a.custom-BIS",function(e){
            e.preventDefault;
            displayBISCustomPopup($(this));
            return false;
        })


        $(document).on("click",_THIS.elemContainer + " .product-control-quantity a.minus",function(e){
            e.preventDefault;
            qtyUpdate($(this),"minus");
            return false;
        })

        $(document).on("click",_THIS.elemContainer + " .product-control-quantity a.plus",function(e){
            e.preventDefault;
            qtyUpdate($(this),"plus");
            return false;
        })


        $(document).on("click",_THIS.elemContainer + " .product-form__cart-submit",function(e){
            e.preventDefault;
            addToBag($(this))
            return false;
        })

        $(document).on("click",_THIS.elemContainer + " .product-item-swatches a",function(e){
            e.preventDefault;
            selectColour($(this));
            return false;
        })

        $(document).on("click",_THIS.elemContainer + " .sizeoption a",function(e){
            e.preventDefault;
            localStorage.setItem("country-region-size", $(this).text());
            selectSize($(this));
            return false;
        })

        $(document).on("click",_THIS.elemContainer + " .product-details .tab-title a",function(e){
            e.preventDefault;
            selectTab($(this));
            return false;
        })

        
        
        initThumbNails($(_THIS.elemContainer + " .thumbnails-wrap .prev"))
        window.onresize = function(){
            initThumbNails($(_THIS.elemContainer + " .thumbnails-wrap .prev"))
        }

        //Main Image Viewer Thumbnails Navigation
        $(document).on("click",_THIS.elemContainer + " .thumbnails-wrap .prev",function(e){
            e.preventDefault;
            navigateThumnails($(this),"prev")
            return false;
        })
        
        $(document).on("click",_THIS.elemContainer + " .thumbnails-wrap .next",function(e){
            e.preventDefault;
            
            navigateThumnails($(this),"next")
            return false;
        })
        
        $(document).on("click",_THIS.elemContainer + " .thumb-media-slide",function(e){
            e.preventDefault;
            //console.log("clicked")
            if($(this).hasClass("slide-sel")){
                return false;
            }
            $(this).parent().find(".thumb-media-slide").removeClass("slide-sel")
            $(this).addClass("slide-sel");
            
            $(this).closest(".thumbnails-wrap").parent().find(".product-image-slideshow").cycle('goto', $(this).index());
            var elem = $(this).closest(".thumbnails-wrap").parent().find(".product-image-slideshow");
            
            (async () => {
                const { default:models } = await import(theme.components.modelsURL);
                    var cycleApi = elem.data('cycle.API')
                    //console.log(cycleApi)
                    models.loadMedia(elem,null, cycleApi.getSlideOpts());
                })();

            return false;
        })
        
        


        

    }
}


export function quickView(){
    var _THIS = this;
    this.elem = null;
    this.popupInstance = null;
    this.modelInstance = null;
    this.init = function(){
        
        $(document).on("click",".quickview-link",function(e){
            e.preventDefault();
            _THIS.elem = $(this);

            (async () => {
                const { checkLibrary } = await import(theme.components.commonURL);

            
                checkLibrary($.fancybox, theme.components.modalLibraryURL, function(){
                    displayQuickview();
                })
                
            })();
            
            
        })
    }
    

    var getQuickviewHTML = function(phandle,callback){
        $.ajax({
            type: 'GET',
            url:window.Shopify.routes.root + 'products/' + phandle + '?view=quickview',
            success: function(response) {
                if(callback != null) return callback.call(this,response);
            },
            error: function(status) {
                console.warn( 'ERROR', status );
            }
        })
    }


    var displayQuickview = function(){

        $.fancybox.close("true");

        _THIS.popupInstance  =  $.fancybox.open('<div data-limoniapps-discountninja-product-quickview data-limoniapps-discountninja-product-handle=' + product.handle + '" id="quickview-product-template" class="layout-quickview"><div class="wrap-content"><div class="loader-content"><img src="' + theme.loaderImage + '" /></div></div></div>',{
            afterShow : function( instance, current ) {
    
                getQuickviewHTML(_THIS.elem.attr("data-product-handle"),function(qhtml){
                 
                        
                       
                        (async () => {
                            const { default:models } = await import(theme.components.modelsURL);

                            $("#quickview-product-template .wrap-content").html(qhtml)
                            models.updateQuickViewModelsDisplay();
                             

                            var instProduct = new product();
                            instProduct.init("#quickview-product-template")

                            
                        
                        })();
                        
                        
                    
                    //Update the product link
                    //$("#quickview-product-template .full-details a").attr("href",producturl)
                    
                });
            }	
        });
    }

   
    
}

